import { Controller } from "@hotwired/stimulus" 
import Cleave from "cleave.js"  

// Connects to data-controller="mask" 
export default class extends Controller {
  static targets = ["input"]
  static values = {
    type: String
  }
  
  cleaveInstance = null
  
  connect() {
    if (this.typeValue === "price") {
      this.initPriceMask()
    } else if (this.typeValue === "percentage") {
      this.initPercentageMask()
    } else if (this.typeValue === "phone") {
      this.initPhoneNumberMask()
    } else if (this.typeValue === "card") {
      this.initCardMask({ target: this.inputTarget })
    } else if (this.typeValue === "card_expiry") {
      this.initCardExpiryMask({ target: this.inputTarget })
    } else if (this.typeValue === "cpf_cnpj") {
      this.inputTarget.addEventListener('input', this.formatCpfCnpj.bind(this))
      this.formatCpfCnpj({ target: this.inputTarget })
    } else {
      this.inputTarget.addEventListener('input', this.handleInput.bind(this))
      this.handleInput({ target: this.inputTarget })
    }
  }
  
  disconnect() {
    if (this.typeValue !== "price" && this.typeValue !== "percentage") {
      this.inputTarget.removeEventListener('input', this.handleInput.bind(this))
    }
    
    if (this.cleaveInstance) {
      this.cleaveInstance.destroy()
      this.cleaveInstance = null
    }
  }
  
  initPriceMask() {
    this.cleaveInstance = new Cleave(this.inputTarget, {
      numeral: true,
      numeralDecimalMark: ',',
      delimiter: '.',
      prefix: 'R$ ',
      // Sem isto o campo vazio já nasce com um "R$ " solto, que esconde o
      // placeholder e parece campo preenchido pela metade.
      noImmediatePrefix: true,
      numeralDecimalScale: 2,
      numeralPositiveOnly: false,
      rawValueTrimPrefix: true
    })
  }

  initPhoneNumberMask() {
    this.cleaveInstance = new Cleave(this.inputTarget, {
      delimiters: ['(', ') ', '-'],
      blocks: [0, 2, 5, 4],
      numericOnly: true
    })
  }
  
  initPercentageMask() {
    this.cleaveInstance = new Cleave(this.inputTarget, {
      numeral: true,
      numeralDecimalMark: ',',
      delimiter: '.',
      prefix: '% ',
      numeralDecimalScale: 2,
      numeralPositiveOnly: false,
      rawValueTrimPrefix: true
    })
  }
  
  handleInput(event) {
    switch(this.typeValue) {
      case "cnpj":
        this.formatCnpj(event)
        break
      case "cpf":
        this.formatCpf(event)
        break
    }
  }

  formatCpfCnpj(event) {
    let value = event.target.value.replace(/\D/g, '')
  
    if (value.length <= 11) {
      if (value.length > 11) {
        value = value.slice(0, 11)
      }
      
      value = value.replace(/^(\d{3})(\d)/, '$1.$2')
      value = value.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      value = value.replace(/\.(\d{3})(\d)/, '.$1-$2')
    } else {
      if (value.length > 14) {
        value = value.slice(0, 14)
      }
      
      value = value.replace(/^(\d{2})(\d)/, '$1.$2')
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
      value = value.replace(/(\d{4})(\d)/, '$1-$2')
    }
    
    event.target.value = value
  }
  
  formatCnpj(event) {
    let value = event.target.value.replace(/\D/g, '')
    
    if (value.length > 14) {
      value = value.slice(0, 14)
    }
    
    value = value.replace(/^(\d{2})(\d)/, '$1.$2')
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
    value = value.replace(/(\d{4})(\d)/, '$1-$2')
    
    event.target.value = value
  }
  
  formatCpf(event) {
    let value = event.target.value.replace(/\D/g, '')
    
    if (value.length > 11) {
      value = value.slice(0, 11)
    }
    
    value = value.replace(/^(\d{3})(\d)/, '$1.$2')
    value = value.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    value = value.replace(/\.(\d{3})(\d)/, '.$1-$2')
    
    event.target.value = value
  }

  initCardExpiryMask(event) {
    this.cleaveInstance = new Cleave(event.target, {
      date: true,
      datePattern: ['m', 'y']  // MM/YY format (matches physical card)
    })
  }

  initCardMask(event) {
    const input = event.target
    this.cleaveInstance = new Cleave(input, {
      creditCard: true,
      onCreditCardTypeChanged: (type) => {
        // Dispatch custom event with card type
        input.dispatchEvent(new CustomEvent('cardTypeChanged', {
          detail: { type },
          bubbles: true
        }))
      }
    })
  }
}